"use strict";

import { initMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { initGuestConfirmationForm } from '../components/guest-confirmation-form.js';

export function initweddingSquad() {
  console.log("Initialisation de la page weddingSquad");
  initBanner();
  initMenu();
  if ($('.guest-of-honor img').length > 0) {
    $('.guest-of-honor').hover(
      function () {
        const imgg = $(this).find('img');
        var activeSrc = imgg.data('active-src');
        imgg.attr('src', activeSrc);
      },
      function () {
        const imgg = $(this).find('img');
        var Src = imgg.data('src');
        imgg.attr('src', Src);
      }
    );
  }
  initGuestConfirmationForm();
  initFooter();
}

module.exports = { initweddingSquad };
